// extracted by mini-css-extract-plugin
export default {"container":"Banner--container--Os1cD"};